import { render, staticRenderFns } from "./KeyAccessAlt.vue?vue&type=template&id=cc8c7f04&"
import script from "./KeyAccessAlt.vue?vue&type=script&lang=js&"
export * from "./KeyAccessAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports